var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-888 -7134) translate(0 6947) translate(888 187)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#EDECF5",
    rx: 21.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L22 0 22 22 0 22z",
    transform: "translate(11 11)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#82889C",
    fillRule: "nonzero",
    d: "M16.528 15.232l3.278 3.277c.358.358.358.939 0 1.297s-.939.358-1.297 0l-3.277-3.278c-1.46 1.171-3.277 1.808-5.149 1.805-4.554 0-8.25-3.696-8.25-8.25s3.696-8.25 8.25-8.25 8.25 3.696 8.25 8.25c.003 1.872-.634 3.689-1.805 5.15zm-.028-5.149c0-3.545-2.872-6.416-6.417-6.416s-6.416 2.87-6.416 6.416c0 3.545 2.87 6.417 6.416 6.417 1.67.003 3.273-.647 4.47-1.81l.137-.138c1.163-1.196 1.813-2.8 1.81-4.469z",
    transform: "translate(11 11)"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.293f63a4c149317627bb3fb194600a5c.svg";
export { ForwardRef as ReactComponent };